import axios from '@/libs/api.request'

// ========== 弹窗规则管理接口 ==========
// Base path: /popup/rules

// GET - 分页查询弹窗规则
// Params: current, size, popupRuleName, status, popupId, crowdIds, langIds, countryCodeList, triggerType
export const getPushList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/popup/rules'
  })
}

// POST - 新增弹窗规则
// Body: { popupRuleName, popupId, popupCount, triggerType, watchingDurationType, durationMin, durationMax, crowdIds, langIds, countryCodes }
export const addPush = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/popup/rules'
  })
}

// PUT - 编辑弹窗规则
// Body: { id, popupRuleName, popupId, popupCount, triggerType, watchingDurationType, durationMin, durationMax, crowdIds, langIds, countryCodes }
export const editPush = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/popup/rules'
  })
}

// GET - 查询弹窗规则详情
export const getPushInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/popup/rules/' + id
  })
}

// DELETE - 删除弹窗规则
export const delPush = (id) => {
  return axios.request({
    method: 'delete',
    url: '/popup/rules/' + id
  })
}

// PUT - 触发弹窗规则状态 (开启/关闭)
export const changePushStatus = (id) => {
  return axios.request({
    method: 'put',
    url: '/popup/rules/trigger/' + id
  })
}
